import { render, staticRenderFns } from "./BalanceTransfers.vue?vue&type=template&id=e41a95ee&scoped=true&"
import script from "./BalanceTransfers.vue?vue&type=script&lang=js&"
export * from "./BalanceTransfers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e41a95ee",
  null
  
)

export default component.exports